import React from 'react';
import classes from './Answers.module.scss';
import Answer from "./Answer/Answer";

const answers = ( props ) => {

    return (
        <div className={classes.Answers}>
            { props.answerList.map( ( theAnswer, answerIndex ) => {
                return (
                    <Answer key={answerIndex}
                            questionIndex={props.questionIndex}
                            answerIndex={answerIndex}
                            onChooseAnswer={props.onChooseAnswer}
                            isSelectedAnswer={(props.selectedAnswer === answerIndex)}
                            version={props.version}
                    >
                        {theAnswer.answer}
                    </Answer>
                );
            } ) }
        </div>
    );

};

export default answers;
